// extracted by mini-css-extract-plugin
export default {"tabs":"tabs___fMTj1","tab":"tab___LYsxA","active":"active___LnDTX","table":"table___b9UGH","header":"header___pixhQ","column":"column___IOpwo","item":"item___Db7Yr"};